import {TableSettings} from '../../interfaces/table-setting.interface';
import {PageableDTO} from '../../openapi/fakturierung-openapi';


export enum ProduktColumn {
  Nummer = 'nummer',
  Bezeichnung = 'produkt',
  Preis = 'preis',
  USt = 'ust',
  Actions = 'actions',
}

export interface ProduktTableState {
  displayedIds: string[];
  tableSettings: TableSettings;
  pageableDto: PageableDTO;
  totalPages: number;
  produkteLoaded: boolean;
}
